import React from 'react';
import {
    Input as ChakraInput,
    InputProps as ChakraInputProps,
} from '@chakra-ui/react';

// eslint-disable-next-line no-shadow
export enum InputTheme {
    Light,
    Dark
}

export type InputProps = {
    theme?: InputTheme
} & ChakraInputProps

export const Input = ({
    ...props
}: InputProps) => (
    <ChakraInput
        border="1px solid black"
        fontSize="1.5rem"
        {...props}
    />
);
